import { FormValues } from '../../../Store/reducers/formReducer/types'
import {
    getGenreName,
    getOccupationName,
    calculateWorkYears,
} from './ResumeAutoGenerateModal.helpers'
import { EMPLOYMENT_MAP } from './ResumeAutoGenerateModal.constants'

interface GenerateResumeTextParams {
    formState: FormValues
    selectedDuties: string[]
    selectedSpend: string
    selectedSize: string
}

const generateCompanyLine = (
    companyName: string,
    brandName: string,
    storeName: string
): string => {
    let companyLine = `・${companyName}`
    if (brandName && storeName) {
        companyLine += ` / ${brandName} ${storeName}`
    } else if (brandName) {
        companyLine += ` / ${brandName}`
    } else if (storeName) {
        companyLine += ` / ${storeName}`
    }
    return companyLine
}

const generateGenreLine = (
    genreName: string,
    selectedSize: string,
    selectedSpend: string
): string => {
    if (!genreName) return ''
    return `・${genreName} / ${selectedSize}・客単価${selectedSpend}\n`
}

const generateWorkPeriodLine = (
    workStartYear: string,
    workStartMonth: string,
    occupationName: string,
    employmentName: string,
    workYears: string
): string => {
    if (
        !workStartYear ||
        !workStartMonth ||
        !occupationName ||
        !employmentName ||
        !workYears
    ) {
        return ''
    }
    return `・${workStartYear}年${workStartMonth}月から${occupationName}(${employmentName})として${workYears}年間勤務\n`
}

const generateDutiesSection = (selectedDuties: string[]): string => {
    if (selectedDuties.length === 0) return ''
    const dutiesList = selectedDuties.map(duty => `・${duty}`).join('\n')
    return '\n【業務内容】\n' + dutiesList
}

export const generateResumeText = ({
    formState,
    selectedDuties,
    selectedSpend,
    selectedSize,
}: GenerateResumeTextParams): string => {
    const resumeData = formState.userResumesAttributes[0]
    const companyName = resumeData?.companyName || ''
    const brandName = resumeData?.brandName || ''
    const storeName = resumeData?.storeName || ''
    const genreName = getGenreName(resumeData?.genreId)
    const occupationName = getOccupationName(resumeData?.occupationIds)
    const employmentName =
        EMPLOYMENT_MAP[resumeData?.employmentId as number] || ''
    const workStartYear = resumeData?.workStartYear || ''
    const workStartMonth = resumeData?.workStartMonth || ''
    const workEndYear = resumeData?.workEndDateYear
    const workEndMonth = resumeData?.workEndDateMonth
    const workYears = calculateWorkYears(
        workStartYear,
        workStartMonth,
        workEndYear,
        workEndMonth
    )

    const companyLine = generateCompanyLine(companyName, brandName, storeName)
    const genreLine = generateGenreLine(genreName, selectedSize, selectedSpend)
    const workPeriodLine = generateWorkPeriodLine(
        workStartYear,
        workStartMonth,
        occupationName,
        employmentName,
        workYears
    )
    const dutiesSection = generateDutiesSection(selectedDuties)

    return `${companyLine}\n${genreLine}${workPeriodLine}${dutiesSection}`
}
